var render = function render(){var _vm=this,_c=_vm._self._c;return _vm._m(0)
}
var staticRenderFns = [function (){var _vm=this,_c=_vm._self._c;return _c('div',{staticStyle:{"height":"100%"}},[_c('div',{staticClass:"uc-top-header"},[_c('div',{staticClass:"top-logo-bg"})]),_c('div',{staticClass:"content"},[_c('iframe',{attrs:{"src":"https://account.glodon.com/agreementConcise","width":"100%","height":"100%","frameborder":"0"}})])])
}]

export { render, staticRenderFns }